import { createBrowserRouter } from "react-router";
import { withFaroRouterInstrumentation } from "@grafana/faro-react";

// Misc pages
import ErrorPage from "src/pages/error-page";

// Auth
import Login from "src/pages/login";

// Main
import Main from "src/pages/main";
import Home from "src/pages/main/home";
import Call from "src/pages/main/call";
import ConfigScreen from "./pages/main/config";

const browserRouter = createBrowserRouter(
  [
    {
      path: "/",
      element: <Main />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/call",
          element: <Call />,
        },
        {
          path: "/config",
          element: <ConfigScreen />,
        },
      ],
    },

    {
      path: "/login",
      element: <Login />,
    },
  ],
  { basename: import.meta.env.BASE_URL }
);

export default withFaroRouterInstrumentation(browserRouter);
